const Desk = ({children,from='from-purple-300',to='to-teal-400',via='via-cyan-200'}) => {


    return <div className={from+' '+to+' '+via+' bg-gradient-to-tr p-5 lg:p-20 rounded-md'}>
        {children}
    </div>
}

export default Desk